export default "__VITE_ASSET__a4bd8e7f__"